'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--AreaGraph';

var EntypoAreaGraph = function EntypoAreaGraph(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M20,2v16H0.32c-0.318,0-0.416-0.209-0.216-0.465l4.469-5.748c0.199-0.256,0.553-0.283,0.789-0.062l1.419,1.334c0.235,0.221,0.572,0.178,0.747-0.096l3.047-4.74c0.175-0.273,0.509-0.312,0.741-0.09l2.171,2.096c0.232,0.225,0.559,0.18,0.724-0.1l5.133-7.785C19.51,2.062,19.75,2,20,2z' })
    );
};

exports.default = EntypoAreaGraph;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/AreaGraph.js
// module id = 7207
// module chunks = 0